var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statusAndRole"},[_vm._m(0),_c('div',{staticClass:"status"},[_c('label',[_vm._v("Роль")]),(_vm.roles)?_c('span',{staticClass:"role",style:({
        backgroundColor: _vm.roles[0].back_color,
        color: _vm.roles[0].text_color,
      })},[_vm._v(_vm._s(_vm.roles !== '' ? _vm.roles[0].role_name : 'Не назначенно'))]):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status"},[_c('label',[_vm._v("Статус")]),_c('span',[_vm._v("Без статуса")])])
}]

export { render, staticRenderFns }